var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer is-warning"},[_c('p',{staticClass:"text"},[_vm._v(" Made by "),_c('a',{attrs:{"href":"https://jntech.pro/","target":"_blank"}},[_vm._v("JN TECHNOLOGY")]),_vm._v(" - "),_c('Popup',{staticClass:"popup"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }